// Deep-link bridge for email "Manage This Task" links (`/tasks/:taskId`).
// The tasks index already opens CreateTaskModal via `?id=`; this route
// preserves that flow while accepting the path-based URLs used in emails.
import { Redirect, useLocalSearchParams } from 'expo-router';

export default function TaskDeepLinkRoute() {
  const { taskId } = useLocalSearchParams();
  const id = Array.isArray(taskId) ? taskId[0] : taskId;

  if (!id) {
    return <Redirect href="/tasks" />;
  }

  return <Redirect href={`/tasks?id=${encodeURIComponent(id)}`} />;
}
